export default "__VITE_ASSET__CAlQByce__"